export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  } else {
    console.log("GA event:", eventName, params);
  }
};